import { IAction, KEEP_THE_SAME, StateStatus } from 'redux/utils/common';
import * as Types from './type';
import * as ProductService from 'services/api/product';
import { LanguagesEnum } from 'constants/languages';
import {
  IFavoritesData,
  IClientCollectionsData,
  ICustomersMiniProfileData,
} from 'services/api/client';
import _ from 'lodash';

export interface IProductLocation {
  id: number;
  firstname: string;
  lastname: string;
  email: string;
  position: {
    srid: number | null;
    version: number | null;
    points: [
      {
        x: number | null;
        y: number | null;
        z: number | null;
        m: number | null;
      }
    ];
    figures: [
      {
        attribute: number | null;
        pointOffset: number | null;
      }
    ];
    shapes: [
      {
        parentOffset: number | null;
        figureOffset: number | null;
        type: number | null;
      }
    ];
    segments: any[];
  };
  position2: {
    srid: number | null;
    version: number | null;
    points: [
      {
        x: number | null;
        y: number | null;
        z: number | null;
        m: number | null;
      }
    ];
    figures: [
      {
        attribute: number | null;
        pointOffset: number | null;
      }
    ];
    shapes: [
      {
        parentOffset: number | null;
        figureOffset: number | null;
        type: number | null;
      }
    ];
    segments: any[];
  };
  polygons?: any;
  company: string;
  countryid: number | null;
  stateprovinceid: number | null;
  county: number | null;
  cityid: number;
  area: any;
  municipalityid: number | null;
  address1: string;
  address2: string;
  zippostalcode: string;
  phonenumber: string;
  faxnumber: string;
  customattributes: any;
  createdonutc: string;
  radius: number | null;
  displaysetting: number;
  sheet: string | null;
  plan: string | null;
  parcelnumber: string | null;
  block: string | null;
  registrationdepartment: string | null;
  registrationnumber: string | null;
  comments: string | null;
}
export interface IState {
  productBasicInfo: {
    data: ProductService.ProductBasicInfo | null;
    status: StateStatus | null;
  };
  sharing: {
    status: StateStatus | null;
    data: any;
  };
  productLocation: {
    data: IProductLocation | null;
    status: StateStatus | null;
  };
  sendMail: {
    status: StateStatus | null;
    data: any;
  };
  addCollections: {
    status: StateStatus | null;
  };
  addSharingProduct: {
    status: StateStatus | null;
  };
  clientCollectionsPersonal: {
    status: StateStatus | null;
    data: IClientCollectionsData | null;
  };
  addAssignClients: {
    status: StateStatus | null;
  };
  customers: {
    data: Array<ProductService.IMiniProfile>;
    status: StateStatus | null;
  };
  assignees: {
    status: StateStatus | null;
    data: any;
  };
  customerName: {
    status: StateStatus | null;
    data: any;
  };
  propertyName: {
    status: StateStatus | null;
    data: any;
  };
  statusLane: {
    status: StateStatus | null;
    data: any;
  };
  addNewTask: {
    status: StateStatus | null;
  };
  documents: {
    status: StateStatus | null;
    data: Array<any>;
  };
  clientMiniProfiles: {
    status: StateStatus | null;
    data: ICustomersMiniProfileData | null;
  };
  sendMailAdvance: {
    status: StateStatus | null;
    data: any;
  };
}

const initialState: IState = {
  productBasicInfo: {
    data: null,
    status: null,
  },
  sharing: {
    status: null,
    data: null,
  },
  productLocation: {
    data: null,
    status: null,
  },
  sendMail: {
    status: null,
    data: null,
  },
  addCollections: {
    status: null,
  },
  addSharingProduct: {
    status: null,
  },
  clientCollectionsPersonal: {
    status: null,
    data: null,
  },
  addAssignClients: {
    status: null,
  },
  customers: {
    data: [],
    status: null,
  },
  assignees: {
    status: null,
    data: null,
  },
  customerName: {
    status: null,
    data: null,
  },
  propertyName: {
    status: null,
    data: null,
  },
  statusLane: {
    status: null,
    data: null,
  },
  addNewTask: {
    status: null,
  },
  documents: {
    status: null,
    data: [],
  },
  clientMiniProfiles: {
    status: null,
    data: null,
  },
  sendMailAdvance: {
    status: null,
    data: null,
  },
};

const ProductReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_PRODUCT_BASIC_INCO:
      return {
        ...state,
        productBasicInfo: {
          ...state.productBasicInfo,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_SHARING_PRODUCT:
      return {
        ...state,
        sharing: {
          data: action.data,
          status: action.status || null,
        },
      };
    case Types.SET_PRODUCT_LOCATION:
      return {
        ...state,
        productLocation: {
          ...state.productLocation,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SEND_EMAIL_PRODUCT:
      return {
        ...state,
        sendMail: {
          data: action.data,
          status: action.status || null,
        },
      };
    case Types.SET_ADD_COLLECTIONS:
      return {
        ...state,
        addCollections: {
          ...state.addCollections,
          status: action.status || null,
        },
      };
    case Types.SET_ADD_SHARING_PRODUCT:
      return {
        ...state,
        addSharingProduct: {
          ...state.addSharingProduct,
          status: action.status || null,
        },
      };
    case Types.SET_CLIENT_COLLECTION_PERSONAL:
      return {
        ...state,
        clientCollectionsPersonal: {
          ...state.clientCollectionsPersonal,
          status: action.status ?? null,
          data: action.data,
        },
      };
    case Types.SET_ADD_ASSIGN_CLIENTS:
      return {
        ...state,
        addAssignClients: {
          ...state.addAssignClients,
          status: action.status || null,
        },
      };
    case Types.SET_CUSTOMERS:
      return {
        ...state,
        customers: {
          ...state.customers,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_ASSIGNESS:
      return {
        ...state,
        assignees: {
          ...state.assignees,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_CUSTOMER_NAME:
      return {
        ...state,
        customerName: {
          ...state.customerName,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_PROPERTY_NAME:
      return {
        ...state,
        propertyName: {
          ...state.propertyName,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_STATUS_LANE:
      return {
        ...state,
        statusLane: {
          ...state.statusLane,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.ADD_NEW_TASK:
      return {
        ...state,
        addNewTask: {
          ...state.addNewTask,
          status: action.status || null,
        },
      };
    case Types.SET_PRODUCT_DOCUMENT:
      return {
        ...state,
        documents: {
          ...state.documents,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? [...state.documents.data]
              : _.uniqBy(
                  [...state.documents.data, ...action.data],
                  (item) => item?.['id']
                ),
        },
      };
    case Types.SET_CLIENTS_MINI_PROFILES:
      return {
        ...state,
        clientMiniProfiles: {
          ...state.clientMiniProfiles,
          status: action.status || null,
          data: action.data,
        },
      };

    case Types.SEND_EMAIL_ADVANCE_PRODUCT:
      return {
        ...state,
        sendMailAdvance: {
          data: action.data,
          status: action.status || null,
        },
      };

    case Types.RESET_DOCUMENT:
      return {
        ...state,
        documents: {
          status: null,
          data: [],
        },
      };

    default:
      return {
        ...state,
      };
  }
};

export default ProductReducer;
